import { JSONSchema } from "@apidevtools/json-schema-ref-parser";

export const defaultQueryables: JSONSchema = {
  $schema: "https://json-schema.org/draft-07/schema#",
  $id: "https://example.org/queryables",
  type: "object",
  title: "",
  properties: {
    id: {
      $ref: "https://schemas.stacspec.org/v1.0.0/item-spec/json-schema/item.json#/definitions/core/allOf/2/properties/id",
      title: "Item ID",
      description: "Item identifier",
    },
    datetime: {
      description: "Datetime",
      type: "string",
      title: "Acquired",
      format: "date-time",
      pattern: "(\\+00:00|Z)$",
    },
    geometry: {
      $ref: "https://geojson.org/schema/Feature.json",
      title: "Item Geometry",
      description: "Item Geometry",
    },
  },
};

export const defaultQueryableNames = Object.keys(defaultQueryables.properties || {});
